export function GreenIcon() {
    return (
        <span
            style={{
                display: 'inline-block',
                width: 18,
                height: 18,
                minWidth: 18,
                minHeight: 18,
                flexShrink: 0,
                borderRadius: '50%',
                background: '#3cb371',
                border: '1.5px solid #1b7d3c',
                marginRight: 4,
            }}
        />
    );
}
export function YellowIcon() {
    return (
        <span
            style={{
                display: 'inline-block',
                width: 18,
                height: 18,
                minWidth: 18,
                minHeight: 18,
                flexShrink: 0,
                borderRadius: '50%',
                background: '#ffd600',
                border: '1.5px solid #bfa800',
                marginRight: 4,
            }}
        />
    );
}
export function RedIcon() {
    return (
        <span
            style={{
                display: 'inline-block',
                width: 18,
                height: 18,
                minWidth: 18,
                minHeight: 18,
                flexShrink: 0,
                borderRadius: '50%',
                background: '#ff5252',
                border: '1.5px solid #b71c1c',
                marginRight: 4,
            }}
        />
    );
}
export function GrayIcon() {
    return (
        <span
            style={{
                display: 'inline-block',
                width: 18,
                height: 18,
                minWidth: 18,
                minHeight: 18,
                flexShrink: 0,
                borderRadius: '50%',
                background: '#bdbdbd',
                border: '1.5px solid #757575',
                marginRight: 4,
            }}
        />
    );
}
